export const getTextShadow = (progress) => 
    progress > 40 && progress < 60 ? '0 0 2px rgba(0,0,0,0.3)' : 'none';